module.exports = __webpack_public_path__ + "ea3614592ba29b61e9a3da6db1487938.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-close-bar.gif
// module id = 151
// module chunks = 1 2 3 4